import {defineStyleConfig} from '@chakra-ui/react'

import typography from '../foundations/typography'

const textTheme = defineStyleConfig({
  variants: typography.textVariants,
  defaultProps: {
    variant: 'bodyMedium',
  },
})

export default textTheme
